import { useState } from "react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { ShieldCheck } from "@phosphor-icons/react";

export default function ChangePassword() {
  const { setUser, logout } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) { toast.error("Le due password non coincidono"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: current, new_password: next });
      setUser(data);
      toast.success("Password aggiornata");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="change-password-form">
        <div className="flex items-center gap-2 mb-6">
          <div className="h-9 w-9 rounded-sm bg-primary flex items-center justify-center text-primary-foreground">
            <ShieldCheck size={20} weight="bold" />
          </div>
          <div>
            <div className="font-head font-bold text-base leading-tight">Cambio password obbligatorio</div>
            <div className="text-[11px] uppercase tracking-widest text-muted-foreground">Primo accesso</div>
          </div>
        </div>
        <p className="text-sm text-muted-foreground mb-5">
          Per motivi di sicurezza devi sostituire la password provvisoria fornita dal responsabile.
        </p>
        <div className="space-y-3.5">
          <div>
            <Label className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Password provvisoria</Label>
            <Input type="password" required value={current} onChange={(e) => setCurrent(e.target.value)}
              className="mt-1.5 rounded-sm" data-testid="cp-current" />
          </div>
          <div>
            <Label className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Nuova password (min 8 caratteri)</Label>
            <Input type="password" required value={next} onChange={(e) => setNext(e.target.value)}
              className="mt-1.5 rounded-sm" data-testid="cp-new" />
          </div>
          <div>
            <Label className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Conferma nuova password</Label>
            <Input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
              className="mt-1.5 rounded-sm" data-testid="cp-confirm" />
          </div>
        </div>
        <Button type="submit" disabled={busy} className="w-full mt-6 rounded-sm font-semibold" data-testid="cp-submit">
          {busy ? "Salvataggio..." : "Imposta nuova password"}
        </Button>
        <button type="button" onClick={logout} className="w-full mt-3 text-xs text-muted-foreground hover:text-foreground" data-testid="cp-logout">
          Esci
        </button>
      </form>
    </div>
  );
}
